import React from "react";
import { AppPage, MimaText } from "../../components";
import styles from "../../assets/styles/Dashboard/Dashboard.module.scss";

const Dashboard = () => {
  return (
    <AppPage>
      <MimaText variant="h1" align="center" mt={5}>
        To be Continued
      </MimaText>
    </AppPage>
  );
};

export default Dashboard;
